import axios, { AxiosRequestConfig } from 'axios'

import { IRecommend } from '@/types/recommend'

export const getRecommends = async (
  q: string,
  categoryId = -1,
): Promise<IRecommend[]> => {
  const config: AxiosRequestConfig = {
    params: {
      q,
      categoryId,
    },
  }
  try {
    const response = await axios.get<IRecommend[]>('recommend', config)
    return response.data
  } catch (error) {
    console.error(error)
    throw new Error('error.recommends.getRecommends')
  }
}
